import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Logo from "../assets/logo.png";
import { CheckCircle, PinDrop } from "@mui/icons-material";
import {
  LoadScript,
  GoogleMap,
  Marker,
  Autocomplete,
} from "@react-google-maps/api";
import { useGeolocated } from "react-geolocated";
import PhoneInput from "react-phone-input-2";
const googleMapsApiKey = "AIzaSyAOFJnj9gYTIPNZ3e57zsVi74X5t4j73CY";
const RSVPPage = ({ qrData }) => {
  const [data, setData] = useState({});
  const mapRef = useRef(null);
  const { coords } = useGeolocated({
    positionOptions: {
      enableHighAccuracy: true,
    },
    userDecisionTimeout: 5000,
  });
  const [notification, setNotification] = useState("");
  const [error, setError] = useState("");
  const [mapDialogOpen, setMapDialogOpen] = useState(false);
  const [loading, setLoading] = useState("");
  const [selectedLocation, setSelectedLocation] = useState({
    lat: null,
    lng: null,
  });
  const [autocomplete, setAutocomplete] = useState(null);
  useEffect(() => {
    if (coords) {
      setData((prev) => ({
        ...prev,
        lat: coords.latitude,
        lng: coords.longitude,
      }));
      setSelectedLocation({
        lat: coords.latitude,
        lng: coords.longitude,
      });
      handleMapClick(coords.latitude, coords.longitude);
    }
  }, [coords]);
  const onLoad = (autocompleteInstance) => {
    setAutocomplete(autocompleteInstance);
  };
  const geocodeLatLng = (lat, lng) => {
    const geocoder = window?.google?.maps
      ? new window.google.maps.Geocoder()
      : null;

    return new Promise((resolve, reject) => {
      geocoder?.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK") {
          if (results[0]) {
            console.log("Geocoding result: ", results[0]); // Log the full result
            resolve(results[0]);
          } else {
            reject("No results found");
          }
        } else {
          reject("Geocoder failed due to: " + status);
        }
      });
    });
  };
  const handleMapClick = async (lat, lng) => {
    try {
      const result = await geocodeLatLng(lat, lng);
      console.log(result);

      const addressComponents = result.address_components;
      let city = "";
      let state = "";
      let zip = "";
      let country = "";
      let address = result.formatted_address || "";

      // Extract city, state, zip, and country from the address components
      console.log(addressComponents);
      for (let component of addressComponents) {
        const types = component.types;

        if (types.includes("locality")) {
          city = component.long_name;
        }
        if (types.includes("administrative_area_level_1")) {
          state = component.long_name;
        }
        if (types.includes("postal_code")) {
          zip = component.long_name;
        }
        if (types.includes("country")) {
          country = component.long_name;
        }
      }

      // If zip code is not found, set it to an empty string
      if (!zip) {
        zip = ""; // Or handle this case based on your needs (e.g., leave it as "")
      }

      // Update userData with the real address data
      setData((prev) => ({
        ...prev,
        address,
        city,
        state,
        zip_code: zip,
        country,
        lat,
        lng,
      }));

      setMapDialogOpen(false); // Close the dialog after selecting
    } catch (error) {
      console.error(error);
      setError("Failed to fetch address data. Please try again.");
    }
  };
  const submitForm = async (e) => {
    if (!data.email) {
      setError("Email is required");
      return;
    }
    e.preventDefault();
    console.log(data);
    setLoading(true);
    let response = await axios({
      method: "post",
      url: "/groupMembers/add",
      data: { ...data, group_uuid: qrData?.group_uuid },
    });
    if (response.data.success) {
      if (qrData.redirection_url) {
        window.location.href = qrData.redirection_url;
      } else {
        window.location.href = `/success/You are now RSVP to ${qrData.group_name}.`;
      }
      setData({});
    }
    setLoading(false);
  };
  const onChangeHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };
  const onPlaceChanged = async () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        setSelectedLocation({ lat, lng });
        // Center the map on the selected place
        try {
          const result = await geocodeLatLng(lat, lng);
          console.log(result);

          const addressComponents = result.address_components;
          let city = "";
          let state = "";
          let zip = "";
          let country = "";
          let address = result.formatted_address || "";

          // Extract city, state, zip, and country from the address components
          console.log(addressComponents);
          for (let component of addressComponents) {
            const types = component.types;

            if (types.includes("locality")) {
              city = component.long_name;
            }
            if (types.includes("administrative_area_level_1")) {
              state = component.long_name;
            }
            if (types.includes("postal_code")) {
              zip = component.long_name;
            }
            if (types.includes("country")) {
              country = component.long_name;
            }
          }

          // If zip code is not found, set it to an empty string
          if (!zip) {
            zip = "N/A"; // Or handle this case based on your needs (e.g., leave it as "")
          }

          // Update userData with the real address data
          setData((prev) => ({
            ...prev,
            address,
            city,
            state,
            zip_code: zip,
            country,
            lat,
            lng,
          }));

          setMapDialogOpen(false); // Close the dialog after selecting
        } catch (error) {
          console.error(error);
          setError("Failed to fetch address data. Please try again.");
        }
      }
    }
  };
  return (
    <div className="sign_up_page">
      <div className="three-corner-curve"></div>
      {notification ? (
        <div className="success_dialogue">
          <div className="success_dialogue_icon">
            <CheckCircle />
          </div>
          <div className="success_dialogue_heading">{notification}</div>
        </div>
      ) : (
        ""
      )}
      <div className="sign_up_logo">
        <img src={Logo} alt="logo" />
      </div>
      <div className="sign_up_form_body">
        {/* <div className="sign_up_form_heading">Name Of Card</div> */}
        <div className="sign_up_form_heading">
          You are about to added to this group {qrData?.group_name || "Name"}
        </div>
        {/* make form for data  */}
        <div className="sign_up_form">
          <div className="input-wrapper">
            <input
              type="text"
              placeholder="First Name"
              value={data.first_name}
              onChange={(e) =>
                setData((prev) => ({
                  ...prev,
                  first_name: e.target.value,
                }))
              }
            />
            {data.first_name && (
              <span
                className="clear-icon"
                onClick={() => setData((prev) => ({ ...prev, first_name: "" }))}
              >
                &times;
              </span>
            )}
          </div>
          <div className="input-wrapper">
            <input
              type="text"
              placeholder="Last Name"
              value={data.last_name}
              onChange={(e) =>
                setData((prev) => ({
                  ...prev,
                  last_name: e.target.value,
                }))
              }
            />
            {data.last_name && (
              <span
                className="clear-icon"
                onClick={() => setData((prev) => ({ ...prev, last_name: "" }))}
              >
                &times;
              </span>
            )}
          </div>

          <div className="input-wrapper">
            <input
              type="text"
              placeholder="Email"
              value={data.email}
              onChange={(e) =>
                setData((prev) => ({
                  ...prev,
                  email: e.target.value,
                }))
              }
            />
            {data.email && (
              <span
                className="clear-icon"
                onClick={() => setData((prev) => ({ ...prev, email: "" }))}
              >
                &times;
              </span>
            )}
          </div>
          <div className="input-wrapper">
            <PhoneInput
              country={"us"} // Default country code
              value={data.phone_number}
              onChange={(phone, country) =>
                setData((prev) => ({
                  ...prev,
                  phone_number: phone,
                  country_code: country.dialCode,
                }))
              }
              inputStyle={{
                width: "250px",

                marginBottom: "1rem",
                border: "none",
                borderRadius: "5px",
                boxShadow: "none",
                height: "30px",
                fontSize: "1rem",
              }}
            />
            {data.phone_number && (
              <span
                className="clear-icon"
                onClick={() =>
                  setData((prev) => ({ ...prev, phone_number: "" }))
                }
              >
                &times;
              </span>
            )}
          </div>
          <div className="input-wrapper">
            <input
              type="text"
              placeholder="City"
              value={data.city}
              onChange={(e) =>
                setData((prev) => ({
                  ...prev,
                  city: e.target.value,
                }))
              }
            />
            {data.city && (
              <span
                className="clear-icon"
                onClick={() => setData((prev) => ({ ...prev, city: "" }))}
              >
                &times;
              </span>
            )}
          </div>

          <div className="input-wrapper">
            <input
              type="text"
              placeholder="State"
              value={data.state}
              onChange={(e) =>
                setData((prev) => ({
                  ...prev,
                  state: e.target.value,
                }))
              }
            />
            {data.state && (
              <span
                className="clear-icon"
                onClick={() => setData((prev) => ({ ...prev, state: "" }))}
              >
                &times;
              </span>
            )}
          </div>
          <div className="input-wrapper">
            <input
              type="text"
              placeholder="Zip Code"
              value={data.zip_code}
              onChange={(e) =>
                setData((prev) => ({
                  ...prev,
                  zip_code: e.target.value,
                }))
              }
            />
            {data.zip_code && (
              <span
                className="clear-icon"
                onClick={() => setData((prev) => ({ ...prev, zip_code: "" }))}
              >
                &times;
              </span>
            )}
          </div>
          <div className="input-wrapper">
            <input
              type="text"
              placeholder="City"
              value={data.city}
              onChange={(e) =>
                setData((prev) => ({
                  ...prev,
                  city: e.target.value,
                }))
              }
            />
            {data.city && (
              <span
                className="clear-icon"
                onClick={() => setData((prev) => ({ ...prev, city: "" }))}
              >
                &times;
              </span>
            )}
          </div>

          <div className="input-wrapper">
            <input
              type="text"
              placeholder="Address"
              value={data.address}
              onChange={(e) => {}}
              onClick={() => setMapDialogOpen(true)}
            />
            {data.address && (
              <span
                className="clear-icon"
                onClick={() => setData((prev) => ({ ...prev, address: "" }))}
              >
                &times;
              </span>
            )}
          </div>
          {loading ? (
            <button id="loading-screen">
              <svg viewBox="0 0 100 100">
                <path
                  d="M10 50A40 40 0 0 0 90 50A40 44.8 0 0 1 10 50"
                  fill="#ffffff"
                  stroke="none"
                >
                  <animateTransform
                    attributeName="transform"
                    type="rotate"
                    dur="1s"
                    repeatCount="indefinite"
                    keyTimes="0;1"
                    values="0 50 51;360 50 51"
                  ></animateTransform>
                </path>
              </svg>
            </button>
          ) : (
            <button onClick={submitForm}>Save</button>
          )}
          {error ? <p style={{ color: "red" }}>{error}</p> : ""}
        </div>
      </div>
      {mapDialogOpen ? (
        <div className="map-dialog">
          <div className="map-dialog-content">
            <LoadScript
              googleMapsApiKey={googleMapsApiKey}
              libraries={["places"]}
            >
              {/* Autocomplete Search Box */}
              <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                <input
                  type="text"
                  placeholder="Search location..."
                  style={{
                    boxSizing: `border-box`,
                    border: `1px solid transparent`,
                    width: `300px`,
                    height: `40px`,
                    padding: `0 12px`,
                    borderRadius: `3px`,
                    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                    fontSize: `16px`,
                    position: "absolute",
                    top: "10px",
                    left: "50%",
                    marginLeft: "-150px",
                    zIndex: "100",
                  }}
                />
              </Autocomplete>

              {/* Google Map Component */}
              <GoogleMap
                ref={mapRef}
                center={{
                  lat: selectedLocation.lat || 37.7749,
                  lng: selectedLocation.lng || -122.4194,
                }}
                zoom={10}
                onClick={(e) => {
                  const lat = e.latLng.lat();
                  const lng = e.latLng.lng();
                  setSelectedLocation({ lat, lng });
                  handleMapClick(lat, lng);
                }}
                mapContainerStyle={{ height: "400px", width: "350px" }}
              >
                {selectedLocation.lat && selectedLocation.lng && (
                  <Marker position={selectedLocation} />
                )}
              </GoogleMap>
            </LoadScript>

            <button
              onClick={() => setMapDialogOpen(false)}
              style={{ marginTop: "20px" }}
            >
              Close Map
            </button>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default RSVPPage;
